import React, { useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';

const HeroSection = () => {
  const dotRef = useRef(null);
  const ringRef = useRef(null);

  useEffect(() => {
    const move = e => {
      if (dotRef.current) {
        dotRef.current.style.left = e.clientX + 'px';
        dotRef.current.style.top  = e.clientY + 'px';
      }
      if (ringRef.current) {
        ringRef.current.style.left = e.clientX + 'px';
        ringRef.current.style.top  = e.clientY + 'px';
      }
    };
    window.addEventListener('mousemove', move);
    return () => window.removeEventListener('mousemove', move);
  }, []);

  return (
    <>
      {/* Custom cursor */}
      <div ref={dotRef}  className="cursor-dot"  />
      <div ref={ringRef} className="cursor-ring" />

      <section style={{ position:'relative', minHeight:'100vh', display:'flex', alignItems:'flex-end', overflow:'hidden' }}>
        {/* Full-bleed background image */}
        <div style={{
          position:'absolute', inset:0, zIndex:0,
          backgroundImage: `url('https://images.unsplash.com/photo-1618221195710-dd6b41faaea6?w=1800&auto=format&fit=crop&q=80')`,
          backgroundSize:'cover', backgroundPosition:'center',
          filter:'brightness(0.45) saturate(0.65)',
        }} />
        {/* Gradient overlay */}
        <div style={{ position:'absolute', inset:0, zIndex:1, background:'linear-gradient(to top, var(--bg) 0%, rgba(28,21,16,0.3) 55%, transparent 100%)' }} />

        {/* Content */}
        <div className="container position-relative pb-5" style={{ zIndex:2, paddingBottom:'80px !important' }}>
          <div className="row">
            <div className="col-lg-10">
              <h1 className="anim-fadeup anim-delay-1" style={{
                fontFamily:'var(--font-disp)', fontWeight:400, lineHeight:0.95,
                fontSize:'clamp(3.8rem, 9vw, 7.5rem)', color:'var(--cream2)',
                letterSpacing:'-0.02em', marginBottom:'2rem',
              }}>
                Code.
                <em style={{ fontStyle:'italic', color:'var(--tan)' }}>Craft.</em>
                Clarity.
              </h1>

              <div className="row align-items-end anim-fadeup anim-delay-2" style={{ maxWidth:720 }}>
                <div className="col-md-8">
                  <p style={{ fontSize:'1.0rem', lineHeight:1.9, fontWeight:300, marginBottom:'2rem' }}>
                    Cegon Soft Tech is a boutique technology studio — building precise, intentional digital products in MERN, Java, Flutter, Python, Digital Marketing & Cyber Security.
                  </p>
                  <Link to="/contact" className="btn-warm">
                    <span>Get in Touch</span>
                    <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
                      <path d="M1 7h12M8 2l5 5-5 5" stroke="currentColor" strokeWidth="1.2"/>
                    </svg>
                  </Link>
                </div>
                <div className="col-md-6 d-none d-md-flex justify-content-end gap-5 pb-1">
                  {[['250+','Projects'],['8+','Years'],['98%','Retention']].map(([n,l]) => (
                    <div key={l} className="text-center">
                      <div className="stat-num">{n}</div>
                      <div className="stat-label">{l}</div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Scroll indicator */}
        <div style={{ position:'absolute', bottom:40, right:48, zIndex:2, display:'flex', flexDirection:'column', alignItems:'center', gap:8 }}>
          <div style={{ width:1, height:60, background:'linear-gradient(to bottom, transparent, var(--tan2))', animation:'fadeIn 2s ease 1s forwards', opacity:0 }} />
          <span style={{ fontFamily:'var(--font-body)', fontSize:'0.6rem', letterSpacing:'0.25em', textTransform:'uppercase', color:'var(--tan2)', writingMode:'vertical-rl' }}>Scroll</span>
        </div>
      </section>
    </>
  );
};

export default HeroSection;
